import { useQuery } from "@tanstack/react-query";
import { extractPaginatedCollection } from "../../utils/apiResponse";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string} deps.language
 * @param {number} deps.pageIndex
 * @param {number} deps.pageSize
 */
export function useGetDataService({
  callApiWithWorker,
  language,
  pageIndex,
  pageSize,
}) {
  return useQuery({
    queryKey: ["dataServices", language, pageIndex, pageSize],
    queryFn: async () => {
      const res = await callApiWithWorker(
        `/dataservices?language=${encodeURIComponent(language)}&page=${pageIndex}&size=${pageSize}`,
        { method: "GET" },
      );

      return extractPaginatedCollection(res);
    },
    keepPreviousData: true,
    staleTime: 30_000,
  });
}
